import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class VehicleBrandService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getVehicleBrands(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressVehicleBrand/GetVehicleBrands', data, messageService);
    }

    public getVehicleModels(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressVehicleBrand/GetVehicleModels', data, messageService);
    }
}
